import { motion } from "framer-motion";
import { MessageCircle, ChevronRight } from "lucide-react";
import { SITE, waLink } from "@/lib/site";

const BG = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=80&auto=format&fit=crop";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta" className="relative section overflow-hidden">
      <div className="absolute inset-0 bg-center bg-cover" style={{ backgroundImage: `url(${BG})` }} />
      <div className="absolute inset-0 bg-black/50" />
      <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at 30% 50%, rgba(201,162,39,0.18), transparent 60%)" }} />

      <div className="relative max-w-[1100px] mx-auto px-6 md:px-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="eyebrow justify-center mb-7 inline-flex"
        >
          Cotización Sin Compromiso
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-display font-semibold text-white text-3xl md:text-5xl lg:text-6xl leading-[1.05]"
        >
          ¿Listo para renovar
          <br />
          <span className="italic font-light text-gold">tus espacios?</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mt-7 text-white/90 text-base md:text-lg font-light max-w-2xl mx-auto"
        >
          Recibe asesoría personalizada, medición profesional y una propuesta a la medida para tu hogar, oficina o negocio.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-10 flex flex-col sm:flex-row gap-4 justify-center"
        >
          <a
            data-testid="final-cta-whatsapp"
            href={waLink(`Hola ${SITE.brandShort}, me gustaría agendar una cotización.`)}
            target="_blank" rel="noreferrer"
            className="btn-ghost text-base px-8 py-4"
            style={{ background: "#25D366", color: "#fff", borderColor: "#25D366" }}
          >
            <MessageCircle size={18} /> WhatsApp
          </a>
          <a
            data-testid="final-cta-cotizar"
            href="#contacto"
            className="btn-gold text-base px-8 py-4"
          >
            Solicitar Cotización <ChevronRight size={16} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
